import ProfilePassword from './ProfilePasswordContainer.vue';

export { ProfilePassword };



// WEBPACK FOOTER //
// ./src/modules/home/profilePassword/index.js